import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=4828a080&"
import script from "./ProductUnit.vue?vue&type=script&lang=ts&"
export * from "./ProductUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports